import AnchorLink from '@/components/AnchorLink';
import { Container } from '@/components/Section';
import { TRUST_ITEMS } from '@/data/content';

export default function TrustStrip() {
  return (
    <div className="bg-white border-b border-ink/10">
      <Container>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 lg:divide-x divide-ink/10">
          {TRUST_ITEMS.map((item) => {
            const body = (
              <>
                <p className="text-lg font-semibold">{item.title}</p>
                <p className="mt-1 text-sm text-ink/70">{item.text}</p>
              </>
            );
            return (
              <li key={item.title} className="py-6 lg:px-8 lg:first:pl-0 lg:last:pr-0">
                {item.href ? (
                  <AnchorLink href={item.href} className="block hover:text-brand transition-colors">
                    {body}
                  </AnchorLink>
                ) : (
                  body
                )}
              </li>
            );
          })}
        </ul>
      </Container>
    </div>
  );
}
